<template>
    <div>
        <b-row>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('student_name')">
                    <b-input-group>
                        <div class="label-as-input"> {{  isNotNullValue(form.student_name) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('student_name')">
                    <b-input-group>
                        <div class="label-as-input"> {{  isNotNullValue(form.student_surname) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('document_type')">
                    <b-input-group>
                        <div class="label-as-input"> {{  isNotNullValue(form.document_type) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('status')">
                    <b-input-group>
                        <div class="label-as-input"> {{ isNotNullValue(form.status) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('start_date')">
                    <b-input-group>
                        <div class="label-as-input"> {{ isNotNullValue(form.start_date) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('end_date')">
                    <b-input-group>
                        <div class="label-as-input"> {{ isNotNullValue(form.end_date) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('approver_name')">
                    <b-input-group>
                        <div class="label-as-input"> {{ isNotNullValue(form.approver_name) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
                <b-form-group :label="$t('approver_surname')">
                    <b-input-group>
                        <div class="label-as-input"> {{ isNotNullValue(form.approver_surname) }}</div>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    //Service
    import PrepStudentDocumentService from '@/services/PrepStudentDocumentService';

    export default {
        props: {
            formId: {
                type: Number
            }
        },
        data() {
            return {
                form: {
                    student_name: null,
                    student_surname: null,
                    document_type: null,
                    status: null,
                    start_date: null,
                    end_date: null,
                    approver_name: null,
                    approver_surname: null,
                }
            }
        },
        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                this.formLoading = true;
                PrepStudentDocumentService.get(id)
                                .then((response) => {
                                    this.form = response.data.data;
                                    this.formLoading = false;
                                })
                                .catch((error) => {
                                    this.showErrors(error)
                                });
            }
        }
    }
</script>
